module.exports = __webpack_public_path__ + "img/search.d0f76ae6.png";